import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import type { ExamDetails } from "@memorang/types";
import type { ExamDetailsResponse } from "./types";

export const fetchExamsList = async (
	signal?: AbortSignal,
): Promise<ExamDetails[]> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.COMMERCE_EXAM_LIST, {
		signal,
	});
	return data.data;
};

export const fetchExamDetails = async (params: {
	examId: string;
	sku?: string;
}): Promise<ExamDetailsResponse> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.COMMERCE_EXAM_DETAILS, {
		params,
	});
	return data.data;
};

export const updateExamDetails = async (params: {
	examId: string;
	metadata: {
		examDate: string;
	};
}) => {
	const { data } = await apiAxios.post(
		API_ENDPOINTS.COMMERCE_EXAM_META_DETAILS,
		params,
	);
	return data.data;
};
